import { useCallback, useEffect } from 'react';
import { TFocusableElement, useFocusContext } from 'src/contexts/FocusContext';

export const useFocus = ({ id, order, group, focusable = true, ref }: TFocusableElement) => {
  const {
    addFocusableElement,
    removeFocusableElement,
    changeFocusableElementProps,
    focusElement,
    blurElement,
    isFocused,
  } = useFocusContext();

  const focus = useCallback(() => {
    if (focusable) {
      focusElement(id);
    }
  }, [focusable, id]);

  const blur = useCallback(() => {
    blurElement(id);
  }, [id]);

  useEffect(() => {
    addFocusableElement({
      id,
      ref,
      order,
      group,
      focusable,
    });

    return () => {
      removeFocusableElement(id);
    };
  }, [id]);

  useEffect(() => {
    changeFocusableElementProps({ id, ref, order, group, focusable });
  }, [id, order, group, focusable]);

  return {
    focused: isFocused(id),
    focus,
    blur,
  };
};
